<template>
  <div>

    <div class="row" v-permission="['contract.create','contract.edit']">
      <div class="col-md-12">



        <KTPortlet
            v-bind="{
            }"
            v-bind:class="{ 'kt-spinner-f': loading }"
        >
          <template v-slot:title>
            <h4 class="">Configurazione</h4>
          </template>
          <template v-slot:body>
            <b-form @submit="onSubmit" @reset="onReset">
              <b-form-group
                  label-cols="4"
                  label-cols-lg="2"
                  label="Nome"
                  label-for="label"
              >
                <b-form-input
                    id="label"
                    v-model="form.firstname"
                    type="text"
                    required
                    placeholder="Inserisci il Nome"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                  label-cols="4"
                  label-cols-lg="2"
                  label="Cognome"
                  label-for="label"
              >
                <b-form-input
                    id="label"
                    v-model="form.lastname"
                    type="text"
                    required
                    placeholder="Inserisci il Cognome"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                  label-cols="4"
                  label-cols-lg="2"
                  label="Email"
                  label-for="label"
              >
                <b-form-input
                    id="label"
                    v-model="form.email"
                    type="text"
                    required
                    placeholder="Inserisci la Email"
                    :readonly="!isNew()&&!canChangeAll()"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                  label-cols="4"
                  label-cols-lg="2"
                  label="Password"
                  label-for="label"
                  v-if="isNew()"
              >
                <b-form-input
                    id="label"
                    v-model="form.password"
                    type="text"
                    required
                    placeholder="Inserisci la Password"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                  v-if="canChangeAll()"
                  label-cols="4"
                  label-cols-lg="2"
                  label="Abilita"
                  label-for="label"
              >
                <b-form-checkbox value="1" v-model="form.enabled" class="mb-2 mr-sm-2 mb-sm-0">
                </b-form-checkbox>
              </b-form-group>
              <b-form-group
                  v-if="canChangeAll()"
                  label-cols="4"
                  label-cols-lg="2"
                  label="Abilita interfaccia"
                  label-for="label"
              >
                <b-form-checkbox value="1"  v-model="form.ui_enabled" class="mb-2 mr-sm-2 mb-sm-0">
                </b-form-checkbox>
              </b-form-group>
              <b-form-group
                  v-if="canChangeAll()"
                  label-cols="4"
                  label-cols-lg="2"
                  label="Abilita API"
                  label-for="label"
              >
                <b-form-checkbox value="1"  v-model="form.api_enabled" class="mb-2 mr-sm-2 mb-sm-0">
                </b-form-checkbox>
              </b-form-group>
              <b-form-group
                  v-if="canChangeAll()"
                  label-cols="4"
                  label-cols-lg="2"
                  label="Admin organizzazione"
                  label-for="label"
              >
                <b-form-checkbox value="1" v-model="form.is_organization_admin" class="mb-2 mr-sm-2 mb-sm-0">
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                  v-if="canChangeAll()"
                  label-cols="4"
                  label-cols-lg="2"
                  label="Organizzazione"
                  label-for="label"
              >
                <org-select
                    v-model="form.organization_id"
                    :options="formoptions.organizations"
                    :reduce="opt => opt.value"
                    label="label"
                    placeholder="Seleziona organizzazione"
                ></org-select>
              </b-form-group>

              <b-form-group
                  v-if="!isNew()"
                  label-cols="4"
                  label-cols-lg="2"
                  label="Cambia password"
                  label-for="label"
              >
                <b-form-checkbox value="1"  v-model="change_pwd" class="mb-2 mr-sm-2 mb-sm-0">
                </b-form-checkbox>
              </b-form-group>
              <b-form-group
                  v-if="!isNew() && change_pwd"
                  label-cols="4"
                  label-cols-lg="2"
                  label="Nuova password"
                  label-for="label"
              >
                <b-form-input
                    id="label"
                    v-model="form.new_password"
                    :type="newpasswordtype"
                    required
                    placeholder="Nuova password"
                ></b-form-input>
                <v-icon
                    @click="newpasswordtype = newpasswordtype=='text'?'password':'text'"
                    small
                    class="mr-2"
                >
                  mdi-eye
                </v-icon>
              </b-form-group>
              <b-form-group
                  v-if="!isNew()"
                  label-cols="4"
                  label-cols-lg="2"
                  label="Forza cambio password"
                  label-for="label"
              >
                <b-form-checkbox value="1" v-model="form.password_expired" class="mb-2 mr-sm-2 mb-sm-0">
                </b-form-checkbox>
              </b-form-group>

              <b-button class="pull-right" type="submit" variant="primary">Salva</b-button>
              <b-button type="reset" variant="danger">Indietro</b-button>

            </b-form>
          </template>
        </KTPortlet>
        <!--end:: Widgets/Activity-->
      </div>

    </div>

    <!-- Group management - separate from main form, shown only when editing -->
    <div class="row" v-if="!isNew()" v-permission="'admingrouporg'">
      <div class="col-md-12">
        <KTPortlet v-bind:class="{ 'kt-spinner-f': loadingGroups }">
          <template v-slot:title>
            <h4 class="">Gruppi</h4>
          </template>
          <template v-slot:body>
            <div v-if="form.groups && form.groups.length">
              <table class="table table-sm mb-3">
                <thead>
                  <tr>
                    <th>Gruppo</th>
                    <th>Amministratore</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="g in form.groups" :key="g.group_id">
                    <td>{{ groupName(g.group_id) }}</td>
                    <td>
                      <b-form-checkbox
                          :checked="g.is_admin == 1"
                          @change="toggleGroupAdmin(g.group_id, $event)"
                      ></b-form-checkbox>
                    </td>
                    <td>
                      <b-button size="sm" variant="outline-danger" @click="removeUserGroup(g.group_id)">Rimuovi</b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="text-muted mb-3">Nessun gruppo assegnato</div>

            <div class="d-flex align-items-center" v-if="formoptions.groups && formoptions.groups.length">
              <b-form-select
                  v-model="newGroupId"
                  :options="availableGroups"
                  class="mr-2"
                  style="max-width:250px"
              >
                <template v-slot:first>
                  <option :value="null">-- Seleziona gruppo --</option>
                </template>
              </b-form-select>
              <b-button variant="primary" size="sm" @click="addUserGroup" :disabled="!newGroupId">Aggiungi</b-button>
            </div>
          </template>
        </KTPortlet>
      </div>
    </div>

  </div>
</template>

<script>
import {SET_BREADCRUMB} from "../../../../store/breadcrumbs.module";
import KTPortlet from "@/views/partials/content/Portlet.vue";
import UserService from "../../../../common/user.service";
import ApiService from "../../../../common/api.service";
import Vue from "vue";
import VSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  data() {
    return {
      loading:false,
      loadingGroups:false,
      change_pwd:false,
      newpasswordtype:'password',
      newGroupId: null,
      formoptions:{
        groups:null,
        organizations:[]
      },
      form: {
      },

    }
  },
  computed: {
    availableGroups() {
      const currentGroupIds = (this.form.groups || []).map(g => g.group_id);
      return (this.formoptions.groups || []).filter(g => !currentGroupIds.includes(g.value));
    }
  },
  components: {
    KTPortlet,
    OrgSelect: VSelect
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Utenti", route: "/setting/user/list" },
      { title: !this.isNew()?"Modifica utente":'Nuovo utente' }
    ]);
  },

  created () {
    this.initialize()
  },
  methods:{
    isNew: function(){
      return !this.currentEditId();
    },
    currentEditId: function(){
      return this.$router.currentRoute.params.id;
    },
    canChangeAll: function(){
      return UserService.hasPermission('super');
    },
    groupName(groupId) {
      const g = (this.formoptions.groups || []).find(g => g.value === groupId);
      return g ? g.text : groupId;
    },
    addUserGroup() {
      if (!this.newGroupId) return;
      this.loadingGroups = true;
      ApiService.post('usergroups/create', { user_id: parseInt(this.currentEditId()), group_id: this.newGroupId })
          .then(() => {
            Vue.customNotifySuccess('Gruppo aggiunto');
            this.newGroupId = null;
            this.reloadGroups();
          })
          .catch(({response}) => {
            Vue.customNotifyError('Errore', response && response.data ? JSON.stringify(response.data) : 'Si prega di riprovare');
            this.loadingGroups = false;
          });
    },
    removeUserGroup(groupId) {
      this.loadingGroups = true;
      ApiService.post('usergroups/destroy', { user_id: parseInt(this.currentEditId()), group_id: groupId })
          .then(() => {
            Vue.customNotifySuccess('Gruppo rimosso');
            this.reloadGroups();
          })
          .catch(({response}) => {
            Vue.customNotifyError('Errore', response && response.data ? JSON.stringify(response.data) : 'Si prega di riprovare');
            this.loadingGroups = false;
          });
    },
    toggleGroupAdmin(groupId, isAdmin) {
      this.loadingGroups = true;
      ApiService.post('usergroups/update', { user_id: parseInt(this.currentEditId()), group_id: groupId, is_admin: isAdmin ? 1 : 0 })
          .then(() => {
            Vue.customNotifySuccess('Aggiornato');
            this.reloadGroups();
          })
          .catch(({response}) => {
            Vue.customNotifyError('Errore', response && response.data ? JSON.stringify(response.data) : 'Si prega di riprovare');
            this.loadingGroups = false;
          });
    },
    onSubmit(evt) {
      evt.preventDefault()
      this.loading=true;
      let datasend = Object.assign({}, this.form);
      datasend.fistname = this.form.firstname;
      if(!this.change_pwd||!this.form.new_password){
        delete(datasend['new_password']);
      }
      if(!datasend.password_expired){
        delete(datasend['password_expired']);
      }
      // groups are managed separately via usergroups endpoints
      delete(datasend['groups']);
      delete(datasend['group_id']);
      ApiService.post('users'+(this.isNew()?'':'/'+this.currentEditId()),datasend)
          .then(({data}) => {
            if(this.isNew()){
              Vue.customNotifySuccess('Salvato');
              this.$router.push({ name: "setting-user-edit", 'params':{'id':data.id} });
              this.loading = false;
              this.reload();
            }else {
              Vue.customNotifySuccess('Salvato');
              this.loading = false;
              this.reload();
            }

          })
          .catch(({response}) => {
            Vue.customNotifyError('Errore',response.data&&response.data.errors?response.data.errors.join(', '):'Si prega di riprovare');
            this.loading = false;
          });
    },
    onReset(evt) {
      this.$router.go(-1);

    },
    initialize () {
      this.reload();
    },
    reloadGroups() {
      ApiService.get('users/'+this.currentEditId())
          .then(({data}) => {
            this.form.groups = data.groups || [];
            this.loadingGroups = false;
          })
          .catch(() => {
            this.loadingGroups = false;
          });
    },
    reload(){
      if(!this.isNew()) {
        this.loading=true;
        ApiService.get('users/'+this.currentEditId())
            .then(({data}) => {
              this.form = data;
              this.loading=false;
            })
            .catch(({response}) => {
              this.loading=false;
            });
      }else{
        this.form.enabled = 1;
        this.form.ui_enabled = 1;
        this.form.api_enabled = 1;
        this.form.organization_id = this.$store.getters.currentUser.organization_id;
      }
      if(UserService.hasPermission(['admingrouporg'])){
        ApiService.get('groups')
            .then(({data}) => {
              this.formoptions.groups = data.rows.map(x => {
                return {value: x.id, text: x.name}
              });
            })
            .catch(() => {});
      }
      if(this.canChangeAll()){
        ApiService.get('organizations')
            .then(({data}) => {
              this.formoptions.organizations = data.rows.map(x => {
                return {value: x.id, label: '#' + x.id + ' - ' + x.name}
              });
            })
            .catch(() => {});
      }
    },
  }
};
</script>
